import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import palette from "src/theme/palette";

const StyledButton = styled(Button)(({ theme }) => ({
  fontSize: "12px",
  backgroundColor: theme.palette.white,
  color: theme.palette.dark,
  border: "none",
  boxShadow: "none",
  borderRadius: "999px",
  "&:hover": {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.dark,
    border: "none",
  },
}));

const WhiteButton = ({ children, ...props }) => {
  return (
    <StyledButton
      variant="outlined"
      sx={props.sx}
      color="secondary"
      onClick={props.onClick}
      fullWidth={props.fullWidth}
    >
      {children}
    </StyledButton>
  );
};

export default WhiteButton;
